import { Button, Row } from 'antd';
import React from 'react';

import { ClearFilterButton } from './components/ClearFilterButton';
import { FilterButton } from './components/FilterButton';
import { SearchInput } from './components/SearchInput';
import { StatusRadioGroup } from './components/StatusRadioGroup';
import { TableComponent } from './components/table';
import { ButtonAdd } from './components/table/TableButtonAdd';

import { TopToolBox } from '../../container/ecommerce/Style';
import { Main, TableWrapper } from '../../container/styled';
import { ThemeLayout } from '../../layout/themeLayout';

import { Cards } from '../../components/cards/frame/cards-frame';
import { PageHeader } from '../../components/page-headers/page-headers';

import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useFetch } from '../../hooks/useFetch';
import { IFetchPropsEstudantes } from './types';

export function Estudantes2() {
  const { user } = useAuth();
  const {
    isFetching,
    dataFetch,
    setSearch,
    filters,
    setStatus,
    handleAddFilters,
    clearFilters,
    refetch,
    currentPage,
    itensPerPage,
    setCurrentPage,
    setColumnOrdenation,
    setItensPerPage,
    totalItens,
  } = useFetch<IFetchPropsEstudantes>({
    baseUrl: 'estudantes',
    endFilter: user?.idEscola ? `&idEscola=${user.idEscola.toString()}` : '',
  });

  const { dataFetch: escolaFetch } = useFetch<any>({
    baseUrl: 'escolas/' + user?.idEscola,
    isArray: false,
  });

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const foo = params.get('idRotatrajeto');
  const title = foo ? 'Estudantes do Trajeto ID: ' + foo : 'Estudantes';
  const back = params.get('back') || '/rotas';
  const history = useHistory();

  return (
    <ThemeLayout>
      <PageHeader
        ghost
        title={`${title} ${escolaFetch ? ' - ' + escolaFetch?.nome : ''}`}
        buttons={[
          <div key="1" className="page-header-actions">
            <Button onClick={() => history.push(back)}>Voltar</Button>
            {filters.length !== 0 && <ClearFilterButton clearFilter={clearFilters} />}
            <FilterButton filters={filters} handleAddFilters={handleAddFilters} clearFilters={clearFilters} />
          </div>,
        ]}
      />

      <Main>
        <Cards headless>
          <TopToolBox>
            <Row gutter={15} className="justify-content-center">
              <SearchInput handleSearch={setSearch} />
              <StatusRadioGroup setStatus={setStatus} />
              <ButtonAdd refetch={refetch} />
            </Row>
          </TopToolBox>

          <TableWrapper className="table-order table-responsive">
            <TableComponent
              setCurrentPage={setCurrentPage}
              setColumnOrdenation={setColumnOrdenation}
              currentPage={currentPage}
              refetch={refetch}
              isLoading={isFetching}
              dataFetch={dataFetch}
              totalItens={totalItens}
              itensPerPage={itensPerPage}
              setItensPerPage={setItensPerPage}
            />
          </TableWrapper>
        </Cards>
      </Main>
    </ThemeLayout>
  );
}
